module.exports = __webpack_public_path__ + "static/media/Engpic3@2x.ef12abda.png";